import { createAsyncThunk } from '@reduxjs/toolkit';
import apiFetch from 'services/apiFetch';
import { fetchAllPlansEndpoint } from '../../../services/plansEndPoints';
import { IPlanDetails } from 'interfaces/plan.interface';
export const fetchAllPlansThunk = createAsyncThunk('fetchAllPlans', async () => {
  try {
    const endpoint = fetchAllPlansEndpoint();
    const resp = await apiFetch<{ count: number; dataset: IPlanDetails[] }>(endpoint).then(
      (res) => res?.data || null
    );
    return resp.dataset;
  } catch (error) {
    let message = 'Something went wrong!';
    if (error instanceof Error) message = error.message;
    else {
      if (typeof error === 'object' && error !== null) {
        if ('message' in error) {
          message = String(error.message);
        }
      }
    }
    throw Error(message);
  }
});
